import React from 'react'

import EyeLids from './cards/EyeLids'
import EyeAnatomy from './cards/EyeAnatomy'
import Pathology from './cards/Pathology'
import Cornea from './cards/Cornea'
import Cataract from './cards/Cataract'
import Glaucoma from './cards/Glaucoma'
import Vitreous from './cards/Vitreous'
import Retina from './cards/Retina'

export default function EyeDrawHome(){
    return(
        <>
          <EyeLids/>
          <EyeAnatomy />
          <Pathology />
          <Cornea />
          <Cataract />
          <Glaucoma />
          <Vitreous />
            <Retina />

        </>
    )
}